var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgRvFriendlySolid = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.309 6c-1.45 0-2.625 1.193-2.625 2.667v7.466c0 1.474 1.175 2.667 2.625 2.667h.525c0 1.767 1.411 3.2 3.15 3.2 1.74 0 3.15-1.433 3.15-3.2h10.5c.58 0 1.05-.477 1.05-1.067s-.47-1.066-1.05-1.066h-1.05v-5.334c0-2.946-2.35-5.333-5.25-5.333H6.309zm-.525 4.267c0-.59.47-1.067 1.05-1.067h4.2c.58 0 1.05.477 1.05 1.067V12.4c0 .59-.47 1.067-1.05 1.067h-4.2c-.58 0-1.05-.477-1.05-1.067v-2.133zm9.45-1.067h2.1c.58 0 1.05.477 1.05 1.067V12.4c0 .59-.47 1.067-1.05 1.067h-2.1c-.58 0-1.05-.477-1.05-1.067v-2.133c0-.59.47-1.067 1.05-1.067zm-6.825 9.6c0-.884.705-1.6 1.575-1.6s1.575.716 1.575 1.6c0 .884-.705 1.6-1.575 1.6s-1.575-.716-1.575-1.6z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRvFriendlySolid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rv-friendly-solid.3bba198a.svg";
export { ForwardRef as ReactComponent };